import { render, staticRenderFns } from "./ItemRow.vue?vue&type=template&id=68bb9b20&"
import script from "./ItemRow.vue?vue&type=script&lang=js&"
export * from "./ItemRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports